var _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuality(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48.3 45.8",
    enableBackground: "new 0 0 48.3 45.8",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#BC9158",
    d: "M29.7,24.1c-0.2,0-0.3,0-0.5-0.1l-5.1-2.7L19,24c-0.3,0.2-0.7,0.1-1.1-0.1c-0.3-0.2-0.5-0.6-0.4-1l1-5.7 l-4.1-4c-0.3-0.3-0.4-0.7-0.3-1c0.1-0.4,0.4-0.6,0.8-0.7l5.7-0.8l2.6-5.2c0.3-0.7,1.5-0.7,1.8,0l2.6,5.2l5.7,0.8 c0.4,0.1,0.7,0.3,0.8,0.7s0,0.8-0.3,1l-4.1,4l1,5.7c0.1,0.4-0.1,0.8-0.4,1C30.1,24,29.9,24.1,29.7,24.1z M17.3,13.2l3.1,3 c0.2,0.2,0.3,0.6,0.3,0.9l-0.7,4.2l3.8-2c0.3-0.2,0.6-0.2,0.9,0l3.8,2L27.7,17c-0.1-0.3,0.1-0.7,0.3-0.9l3.1-3l-4.2-0.6 c-0.3,0-0.6-0.3-0.8-0.5l-1.9-3.8L22.3,12c-0.1,0.3-0.4,0.5-0.8,0.5L17.3,13.2z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#BC9158",
    d: "M23.8,30.9c-8.5,0-15.5-6.9-15.5-15.5c0-8.5,6.9-15.5,15.5-15.5c8.5,0,15.5,6.9,15.5,15.5 C39.2,23.9,32.3,30.9,23.8,30.9z M23.8,1.9c-7.4,0-13.5,6-13.5,13.5s6,13.5,13.5,13.5s13.5-6,13.5-13.5S31.2,1.9,23.8,1.9z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#BC9158",
    d: "M13,45.8C13,45.8,13,45.8,13,45.8c-0.4,0-0.8-0.3-0.9-0.6L9.1,38l-8,1.4c-0.4,0.1-0.8-0.1-1-0.4 c-0.2-0.3-0.2-0.7,0-1.1l9.8-16.5c0.3-0.5,0.9-0.6,1.4-0.3c0.5,0.3,0.6,0.9,0.3,1.4L3,37l6.6-1.1c0.5-0.1,0.9,0.2,1.1,0.6l2.4,6 l5.4-9.7c0.3-0.5,0.9-0.7,1.4-0.4c0.5,0.3,0.7,0.9,0.4,1.4l-6.4,11.5C13.7,45.6,13.4,45.8,13,45.8z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#BC9158",
    d: "M35.3,45.8c-0.4,0-0.7-0.2-0.9-0.5L26,30.2c-0.3-0.5-0.1-1.1,0.4-1.4c0.5-0.3,1.1-0.1,1.4,0.4l7.4,13.3 l2.4-6c0.2-0.4,0.6-0.7,1.1-0.6l6.6,1.1l-6.6-11.2c-0.3-0.5-0.1-1.1,0.3-1.4c0.5-0.3,1.1-0.1,1.4,0.3l7.7,13c0.2,0.3,0.2,0.8,0,1.1 c-0.2,0.3-0.6,0.5-1,0.4l-8-1.4l-2.9,7.2C36,45.6,35.7,45.8,35.3,45.8C35.3,45.8,35.3,45.8,35.3,45.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuality);
export default __webpack_public_path__ + "static/media/quality.8048565f8f8a85b328d726e7c253c5f8.svg";
export { ForwardRef as ReactComponent };